import { countLabel as plural, planLimitText } from '../../../components/subscription/planLockTexts';

/**
 * Vagas de usuário do plano, contadas como o servidor conta (CompanyUserSeats.php):
 * pessoas ativas mais convites pendentes ainda válidos. Usa o "seats" da API e, se não
 * vier, conta pela própria lista.
 */
const isValidInvite = (member) => member.type === 'invitation' && member.status === 'pending'
  && !(member.expiresAt && new Date(String(member.expiresAt).replace(' ', 'T')) < new Date());

export const seatUsageFrom = (seats, members) => {
  if (seats && typeof seats.total === 'number') return seats;
  const active = members.filter((m) => m.type !== 'invitation' && m.status === 'active').length;
  const pendingInvites = members.filter(isValidInvite).length;
  return { active, pendingInvites, total: active + pendingInvites };
};

/**
 * Mesmo texto do bloqueio no servidor: quantas vagas, quantas em convite e o que fazer.
 * `planLabel`: "O plano Essencial" (useCurrentPlanLabel); sem ele, "Seu plano".
 */
export const seatLimitMessage = (usage, limit, planLabel = 'Seu plano') => {
  const base = `${planLimitText(planLabel, limit, 'usuário', 'usuários')}: ${plural(usage.active, 'pessoa com acesso', 'pessoas com acesso')}`;
  if (usage.pendingInvites > 0) {
    return `${base} e ${plural(usage.pendingInvites, 'convite pendente', 'convites pendentes')}. Cancele um convite pendente, remova um acesso ou mude de plano para liberar uma vaga.`;
  }
  return `${base}. Remova um acesso ou mude de plano para liberar uma vaga.`;
};
